import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { colors } from 'src/styles/colors';
import { ZeeFontBold, ZeeFontRegular, getCommerceIcons } from 'src/styles/font';
import { MediaBP as MQ } from 'src/styles/mediaQuery';
import { scrollBarStyling } from 'src/styles/styles';
import { flex } from 'src/styles/utils';
import { CommerceIconsSet } from 'src/utils/constants/IconsConstants';

export const commerceContainer = (onPlayer: boolean) => css`
  ${flex('column', '', 'flex-start')};
  background: ${colors.SearchCardBg};
  border-radius: ${onPlayer ? ' 12px 0px 0px 12px' : '12px 12px 0 0'};
  height: ${!onPlayer ? '82' : '100'}%;
  transition: height 0.5s ease;
  width: 100%;
`;

export const Header = styled.header`
  ${flex()}
  width: 100%;
  gap: 10px;
  padding: 8px;
  border-bottom: 1px solid ${colors.CharlestonGreen};
  ${MQ.MediaMd} {
    padding: 12px;
  }
  ${MQ.MediaLg} {
    gap: 12px;
    padding: 12px 16px;
  }
  ${MQ.MediaXl} {
    padding: 16px;
  }
`;

export const shopIcon = css`
  height: 24px;
  width: 24px;
  ${ZeeFontRegular(24, 24)};
  ${getCommerceIcons(CommerceIconsSet.SHOP)}
  ${MQ.MediaMd} {
    height: 28px;
    width: 28px;
    ${ZeeFontRegular(28, 28)};
  }
`;

export const Title = styled.span`
  ${ZeeFontBold(14, 20)};
  ${MQ.MediaMd} {
    ${ZeeFontBold(18, 24)};
  }
`;

export const Adwrapper = styled.div`
  width: 24px;
  height: 14px;
  border-radius: 2px;
  position: relative;
  background: ${colors.darkYellow};
`;

export const Ad = styled.span`
  position: absolute;
  top: 1px;
  left: 5px;
  color: ${colors.PrimaryWhiteColor};
  ${ZeeFontBold(10, 13.7)}
`;

export const IconWrapper = styled.div`
  margin-left: auto;
  cursor: pointer;
  height: 20px;
  width: 20px;
  ${MQ.MediaXl} {
    height: 24px;
    width: 24px;
  }
`;

export const closeIcon = css`
  height: 18px;
  width: 18px;
  ${ZeeFontBold(18, 18)};
  ${getCommerceIcons(CommerceIconsSet.CLOSE)}
  ${MQ.MediaMd} {
    height: 20px;
    width: 20px;
    ${ZeeFontBold(20, 20)};
  }
  ${MQ.MediaXl} {
    height: 24px;
    width: 24px;
    ${ZeeFontBold(24, 24)};
  }
`;

export const CommerceItems = styled.div`
  ${flex('column', '', 'flex-start')}
  width: 100%;
  gap: 10px;
  height: 97%;
  padding: 8px;
  overflow-y: auto;
  ${MQ.MediaMd} {
    padding: 12px;
  }
  ${MQ.MediaLg} {
    gap: 12px;
    padding: 12px 16px;
  }
  ${MQ.MediaXl} {
    gap: 20px;
    padding: 20px 24px;
  }
  ${scrollBarStyling('2.5px', colors.Transparent)}
  ${MQ.MediaMd} {
    ${scrollBarStyling('5px', colors.Transparent)}
  }
`;
